module.exports = __webpack_public_path__ + "static/media/noLogo.0e2d3465.png";